<template>
  <header class="desktop-header">
    <div class="desktop-header__container mx-auto">
      <div class="desktop-header-logo float-left">
        <router-link to="/">
          <img src="/static/images/ct-learning-logo.png" alt="app logo">
        </router-link>
      </div>

      <div class="desktop-header-nav float-left">
        <nav>
          <router-link to="/">
            <div class="desktop-header-nav__item" v-bind:class="{ 'desktop-header-nav__item--active': navState === 'perf' }">
              학습 분석
            </div>
          </router-link>
          <router-link to="/badges">
            <div class="desktop-header-nav__item" v-bind:class="{ 'desktop-header-nav__item--active': navState === 'badges' }">
              미션 현황
            </div>
          </router-link>
          <a v-bind:href="ctStoreUrl">
            <div class="desktop-header-nav__item">맞춤 학습</div>
          </a>
        </nav>
      </div>

      <div class="desktop-header-profile float-right">
        <a
          v-bind:href="userProfileUrl"
          target="_blank"
          class="desktop-header-profile__image"
          v-bind:style="profileImageStyle"
        />
      </div>

    </div>
  </header>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { isNil } from 'lodash';
  import { CLASSTING_URL, CT_STORE_URL } from '@/config';

  export default {
    name: 'desktop-header',

    props: {
      navState: {
        type: String,
        default: null,
      },
    },

    data() {
      return {
        ctStoreUrl: CT_STORE_URL,
      };
    },

    computed: {
      ...mapGetters([
        'currentUserId',
        'currentUser',
      ]),

      userProfileUrl() {
        if (!isNil(this.currentUserId)) {
          return `${CLASSTING_URL}/users/${this.currentUserId}`;
        }

        return '#';
      },

      profileImageStyle() {
        if (!isNil(this.currentUser) && !isNil(this.currentUser.profile_image)) {
          return {
            'background-image': `url('${this.currentUser.profile_image}')`,
          };
        }

        return {};
      },
    },
  };
</script>

<style lang="scss">
  .desktop-header {
    background-color: #fff;

    .desktop-header__container {
      max-width: 1280px;

      &:before,
      &:after {
        display: table;
        content: " ";
        clear: both;
      }
    }

    .desktop-header-logo {
      padding: 16px 5px 16px 20px;
    }

    .desktop-header-nav {
      padding: 16px 10px;

      a {
        margin-left: 10px;
        margin-right: 30px;
      }
    }

    .desktop-header-nav__item {
      display: inline-block;
      line-height: 28px;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.87);

      &.desktop-header-nav__item--active {
        color: rgba(0, 200, 150, 0.87);
        font-weight: bold;
      }
    }

    .desktop-header-profile {
      padding: 12px 20px;
    }

    .desktop-header-profile__image {
      display: block;
      width: 36px;
      height: 36px;
      border: solid 1px rgba(0, 0, 0, 0.07);
      border-radius: 50%;
      background-color: rgba(204, 204, 204, 0.8);
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;

      &:hover, &:active {
        border: solid 1px rgba(0, 0, 0, 0.2);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// DesktopHeader.vue?40230a2a